import {bymoTemplateMetadataFactoryCreate} from "../../../doppe-sdk";


export namespace BymoTemplateActionInPagePreview {

    export interface TemplateProps {

    }
}

const initialValues = {};

export const BymoTemplateActionInPagePreviewMetadata = bymoTemplateMetadataFactoryCreate<BymoTemplateActionInPagePreview.TemplateProps>()({
    initialValues: initialValues,
    resolveProps: bymoPagePRops => {
        return {
            ...initialValues,
            ...bymoPagePRops
        }
    },
    templatePropsMetadata: {},
    features: [
        'hasActions', 'hasActionButton'
    ]
})